export default __webpack_public_path__ + "static/1-11958607dabd2f653b0ec3d6fbd93671.png";